module.exports = __webpack_public_path__ + "img/logo-sm.1bb01388.png";